var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _rect5, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 52,
    width: 24,
    height: 24,
    fill: "url(#paint0_radial_3124_25301)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 52,
    width: 24,
    height: 24,
    fill: "url(#paint1_radial_3124_25301)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 24,
    height: 24,
    fill: "url(#paint2_radial_3124_25301)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 104,
    width: 24,
    height: 24,
    fill: "url(#paint3_radial_3124_25301)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5V12H11.5V12.5H12ZM47.8536 12.8536C48.0488 12.6583 48.0488 12.3417 47.8536 12.1464L44.6716 8.96447C44.4763 8.7692 44.1597 8.7692 43.9645 8.96447C43.7692 9.15973 43.7692 9.47631 43.9645 9.67157L46.7929 12.5L43.9645 15.3284C43.7692 15.5237 43.7692 15.8403 43.9645 16.0355C44.1597 16.2308 44.4763 16.2308 44.6716 16.0355L47.8536 12.8536ZM12.5 52V12.5H11.5V52H12.5ZM12 13H47.5V12H12V13Z",
    fill: "url(#paint4_linear_3124_25301)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 115.5V116H116.5V115.5H116ZM80.1464 115.146C79.9512 115.342 79.9512 115.658 80.1464 115.854L83.3284 119.036C83.5237 119.231 83.8403 119.231 84.0355 119.036C84.2308 118.84 84.2308 118.524 84.0355 118.328L81.2071 115.5L84.0355 112.672C84.2308 112.476 84.2308 112.16 84.0355 111.964C83.8403 111.769 83.5237 111.769 83.3284 111.964L80.1464 115.146ZM115.5 76V115.5H116.5V76H115.5ZM116 115H80.5V116H116V115Z",
    fill: "url(#paint5_linear_3124_25301)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.354 46.3536C116.158 46.5488 115.842 46.5488 115.646 46.3536L112.464 43.1716C112.269 42.9763 112.269 42.6597 112.464 42.4645C112.66 42.2692 112.976 42.2692 113.172 42.4645L116 45.2929L118.828 42.4645C119.024 42.2692 119.34 42.2692 119.536 42.4645C119.731 42.6597 119.731 42.9763 119.536 43.1716L116.354 46.3536ZM116 12V11.5H116.5V12H116ZM115.5 46V12H116.5V46H115.5ZM116 12.5H76V11.5H116V12.5Z",
    fill: "url(#paint6_linear_3124_25301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6464 80.1464C11.8417 79.9512 12.1583 79.9512 12.3536 80.1464L15.5355 83.3284C15.7308 83.5237 15.7308 83.8403 15.5355 84.0355C15.3403 84.2308 15.0237 84.2308 14.8284 84.0355L12 81.2071L9.17157 84.0355C8.97631 84.2308 8.65973 84.2308 8.46447 84.0355C8.2692 83.8403 8.2692 83.5237 8.46447 83.3284L11.6464 80.1464ZM12 115.5V116H11.5V115.5H12ZM12.5 80.5V115.5H11.5V80.5H12.5ZM12 115H52V116H12V115Z",
    fill: "url(#paint7_linear_3124_25301)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 54,
    width: 56,
    height: 20,
    fill: "url(#paint8_radial_3124_25301)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61H52V67H46V61ZM61 61H67V67H61V61ZM76 61H82V67H76V61Z",
    stroke: "#0088FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54H36V58",
    stroke: "url(#paint9_linear_3124_25301)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74H92V70",
    stroke: "url(#paint10_linear_3124_25301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3124_25301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5405 59.3171) rotate(134.754) scale(23.4928 21.3313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3124_25301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.541 59.3171) rotate(134.754) scale(23.4928 21.3313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3124_25301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.5405 7.31707) rotate(134.754) scale(23.4928 21.3313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3124_25301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.5405 111.317) rotate(134.754) scale(23.4928 21.3313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3124_25301",
    x1: 28.25,
    y1: 12.5,
    x2: 28.25,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3124_25301",
    x1: 86.5,
    y1: 113.5,
    x2: 116,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3124_25301",
    x1: 80.5,
    y1: 12,
    x2: 116,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3124_25301",
    x1: 47.5,
    y1: 111,
    x2: 16,
    y2: 87.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3124_25301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92 74) rotate(-161.047) scale(57.7297 33.3504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3124_25301",
    x1: 38.5858,
    y1: 54,
    x2: 38.5858,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3124_25301",
    x1: 89.4142,
    y1: 74,
    x2: 89.4142,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTech);
export default __webpack_public_path__ + "static/media/ic_tech.5c3fef7bd41d0a3bdc20695e853ebdd4.svg";
export { ForwardRef as ReactComponent };